"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _curryRight = _interopRequireDefault(require("lodash/curryRight"));

var _functools = require("@edison/functools");

var _constants = require("./constants");

var _url = require("./utils/url");

var _datetime = require("./utils/datetime");

var _format = require("./utils/format");

var _errors = require("./errors");

var _response = require("./response");

var _response2 = require("./utils/response");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Request method to make API calls. Implemented on top of Fetch API, therefore
 * you would require a polyfill for it if the browser does not have native
 * support.
 *
 * @public
 * @param {string} url
 * @param {HttpMethod} method
 * @param {RequestOptionals} optional
 * @returns {Promise<any>}
 */
var request = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(url, method, optional) {
    var formattedUrl, fetchParams, res, json;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            formattedUrl = url;

            if ('params' in optional) {
              formattedUrl = (0, _url.formatQueryParams)(url, optional.params, optional.paramsFormat);
            }

            fetchParams = {
              // Removes the need for cache
              cache: _constants.cacheMode.noStore,
              method: method,
              mode: 'mode' in optional ? optional.mode : _constants.DEFAULT_CORS_MODE,
              // $FlowFixMe
              headers: 'headers' in optional ? _objectSpread(_objectSpread({}, _constants.DEFAULT_HEADERS), optional.headers) : _constants.DEFAULT_HEADERS
            }; // Fetch does not handle request body with GET requests

            if (method !== 'GET' && optional.body) {
              if (optional.snakify) {
                fetchParams.body = JSON.stringify((0, _functools.pipe)((0, _curryRight["default"])(_format.snakify)(optional.excludeSnakify), _datetime.demomentize)(optional.body));
              } else {
                fetchParams.body = JSON.stringify((0, _functools.pipe)(_datetime.demomentize)(optional.body));
              }
            }

            if (optional.cache) {
              fetchParams.cache = optional.cache;
            }

            _context.prev = 5;
            _context.next = 8;
            return fetch(formattedUrl, fetchParams);

          case 8:
            res = _context.sent;

            if (!(res.status === 204)) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return", new _response.CustomResponse(res));

          case 11:
            if (!(res.status === 401 && !(0, _response2.isResponseJson)(res.headers))) {
              _context.next = 13;
              break;
            }

            throw new _errors.RequestError('Session expiration', 401, 401, res.headers);

          case 13:
            _context.next = 15;
            return res.json();

          case 15:
            json = _context.sent;

            if (res.ok) {
              _context.next = 18;
              break;
            }

            throw new _errors.RequestError(json.message, json.error_code, res.status, res.headers);

          case 18:
            if (optional.camelize) {
              json = (0, _functools.pipe)((0, _curryRight["default"])(_format.camelize)(optional.excludeCamelize), (0, _datetime.momentize)(_constants.TIMESTAMPED_FIELDS))(json);
            } else {
              json = (0, _functools.pipe)((0, _datetime.momentize)(_constants.TIMESTAMPED_FIELDS))(json);
            }

            return _context.abrupt("return", new _response.CustomResponse(res, json));

          case 22:
            _context.prev = 22;
            _context.t0 = _context["catch"](5);

            if (!(_context.t0 instanceof _errors.RequestError)) {
              _context.next = 28;
              break;
            }

            throw _context.t0;

          case 28:
            throw new _errors.RequestError('', -1);

          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 22]]);
  }));

  return function request(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var _default = request;
exports["default"] = _default;
//# sourceMappingURL=request.js.map